import { render } from "./RevolutionizingAirportOperations.vue?vue&type=template&id=387bb363"
import script from "./RevolutionizingAirportOperations.vue?vue&type=script&lang=js"
export * from "./RevolutionizingAirportOperations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__